var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.333 18.1249C8.26634 18.1249 8.19884 18.114 8.133 18.0924C7.85217 17.9974 7.67634 17.7174 7.713 17.4224L8.45884 11.4582H6.393C6.0605 11.4582 5.7555 11.3049 5.55717 11.0382C5.35884 10.7715 5.29967 10.4357 5.3955 10.1174L7.55634 2.91402C7.743 2.29236 8.30384 1.87402 8.953 1.87402H11.3438C11.8113 1.87402 12.2538 2.10069 12.5272 2.47986C12.8005 2.85902 12.8747 3.34986 12.7272 3.79402L11.7005 6.87402H13.4413C13.813 6.87402 14.1588 7.07402 14.3447 7.39652C14.5297 7.71902 14.5288 8.11902 14.3413 8.43986L8.873 17.814C8.758 18.0099 8.5505 18.1249 8.333 18.1249ZM6.673 10.2082H8.69467C8.993 10.2082 9.278 10.3365 9.47634 10.5607C9.67384 10.7849 9.76634 11.0832 9.72884 11.3799L9.333 14.5474L13.0797 8.12486H11.413C11.0788 8.12486 10.763 7.96319 10.568 7.69236C10.373 7.42152 10.3188 7.07069 10.4247 6.75402L11.543 3.39986C11.5722 3.31152 11.538 3.24402 11.5147 3.21236C11.4913 3.17986 11.4388 3.12569 11.3455 3.12569H8.95467C8.86217 3.12569 8.78134 3.18569 8.75467 3.27402L6.67384 10.209L6.673 10.2082Z",
    fill: "#4C88FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIcon);
export default __webpack_public_path__ + "static/media/flash-icon.3273f46116707213adb51056f50d2a05.svg";
export { ForwardRef as ReactComponent };